import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LargeSemiboldText: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID,
    text = ''
}) => (
    <p className={`${className} ${styles.largeSemiboldText} `} data-testid={testId}>
        {children || text}
    </p>
);

export default LargeSemiboldText;
